var _rect, _rect2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 39.5,
    height: 39.5,
    rx: 19.75,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 39.5,
    height: 39.5,
    rx: 19.75,
    stroke: "#E5E5E5",
    strokeWidth: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_351_3429)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 19.25C14 19.9394 14.1358 20.6221 14.3996 21.2591C14.6635 21.896 15.0502 22.4748 15.5377 22.9623C16.0252 23.4498 16.604 23.8365 17.2409 24.1004C17.8779 24.3642 18.5606 24.5 19.25 24.5C19.9394 24.5 20.6221 24.3642 21.2591 24.1004C21.896 23.8365 22.4748 23.4498 22.9623 22.9623C23.4498 22.4748 23.8365 21.896 24.1004 21.2591C24.3642 20.6221 24.5 19.9394 24.5 19.25C24.5 18.5606 24.3642 17.8779 24.1004 17.2409C23.8365 16.604 23.4498 16.0252 22.9623 15.5377C22.4748 15.0502 21.896 14.6635 21.2591 14.3996C20.6221 14.1358 19.9394 14 19.25 14C18.5606 14 17.8779 14.1358 17.2409 14.3996C16.604 14.6635 16.0252 15.0502 15.5377 15.5377C15.0502 16.0252 14.6635 16.604 14.3996 17.2409C14.1358 17.8779 14 18.5606 14 19.25Z",
    stroke: "#212129",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.25 26.25L23 23",
    stroke: "#212129",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_351_3429"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(11 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch1);
export default __webpack_public_path__ + "static/media/Search1.3129ff0a3efdff07cda34fe364c72e7f.svg";
export { ForwardRef as ReactComponent };